import { render, staticRenderFns } from "./AddResourceForm.vue?vue&type=template&id=f1840b08&"
import script from "./AddResourceForm.vue?vue&type=script&lang=js&"
export * from "./AddResourceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports